import React from 'react'

import { ConferenceProvider } from 'api/conferenceProviders'
import GoogleMeetIcon from 'images/googlemeet-icon.svg'
import MicrosoftTeamsIcon from 'images/msteams-icon.svg'
import ZoomIcon from 'images/zoom-icon.svg'

interface ConferenceTypeIconProps {
  type: ConferenceProvider | undefined
  size?: number
}

export default function ConferenceTypeIcon({
  type,
  size = 16,
}: ConferenceTypeIconProps) {
  if (!type || type === ConferenceProvider.None) return null

  const iconMap = {
    [ConferenceProvider.GoogleMeet]: {
      src: GoogleMeetIcon,
      title: 'Google Meet',
    },
    [ConferenceProvider.Zoom]: {
      src: ZoomIcon,
      title: 'Zoom',
    },
    [ConferenceProvider.MicrosoftTeams]: {
      src: MicrosoftTeamsIcon,
      title: 'Microsoft Teams',
    },
  }
  return <img {...iconMap[type]} width={size} height={size} />
}
